/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uBoxExport = A4uBoxExport;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uBoxExport(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M21.285,4.2,15.722,1.183a1.515,1.515,0,0,0-1.443,0L.409,8.7a.781.781,0,0,0,0,1.373L5.645,12.9Z",
    transform: "translate(0)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M29.591,8.7,24.442,5.906,8.8,14.615,15,17.972l14.591-7.9A.781.781,0,0,0,29.591,8.7Z",
    transform: "translate(0)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M14,20.971,0,13.193V26.652a1.6,1.6,0,0,0,.823,1.4L14,35.371Z",
    transform: "translate(0)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M28,24V20.672a.5.5,0,0,1,.866-.341L36,28l-7.134,7.669A.5.5,0,0,1,28,35.328V32H23a1,1,0,0,1-1-1V25a1,1,0,0,1,1-1Z",
    transform: "translate(0)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M27,18h3V13.193L16,20.971v14.4l4-2.222V23a1,1,0,0,1,1-1h5V19A1,1,0,0,1,27,18Z",
    transform: "translate(0)"
  }));
}